
document.addEventListener('DOMContentLoaded', function() {
    // Inizializza TUTTI i caroselli .multi-item-carousel (supporta più istanze per pagina)
    const carousels = document.querySelectorAll('.multi-item-carousel');

    if (!carousels.length) {
        return;
    }

    carousels.forEach(function(carouselElement) {
        // Navigazione scoped alla singola istanza (bottoni interni al container)
        const nextEl = carouselElement.querySelector('.swiper-button-next');
        const prevEl = carouselElement.querySelector('.swiper-button-prev');

        new Swiper(carouselElement, {
            // Basic settings
            loop: false,
            autoplay: false,

            // Show partial slides
            centeredSlides: false,

            // Navigation arrows (scoped per-instance)
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },

            // Responsive breakpoints
            breakpoints: {
                // Mobile
                0: {
                    slidesPerView: 1.20,
                    spaceBetween: 5,
                },
                // Small tablet
                577: {
                    slidesPerView: 1.33,
                    spaceBetween: 15,
                },
                // Medium tablet
                769: {
                    slidesPerView: 2.33,
                    spaceBetween: 15,
                },
                // Large tablet
                993: {
                    slidesPerView: 3.33,
                    spaceBetween: 20,
                },
                // Desktop
                1200: {
                    slidesPerView: 4.33,
                    spaceBetween: 20,
                }
            }
        });
    });
});